import { Params } from '@angular/router';
import { jwtDecode } from 'jwt-decode';

export class Utils {
    static getParamsFromUrl(url: string): Params {
        const splittedUrl: string[] = url.split('?');
        const properSplittedValueLength: number = 2;
        const params: Params = {};

        if (splittedUrl.length === properSplittedValueLength) {
            const variables: string[] = splittedUrl[1].split('&');

            for (let i: number = 0; i < variables.length; i++) {
                const pair: string[] = variables[i].split('=');

                if (pair.length >= properSplittedValueLength) {
                    const [key, ...values] = pair;

                    params[key] = decodeURIComponent(values.join('='));
                }
            }
        }

        return params;
    }

    static decodeToken(token: string): any {
        try {
            return jwtDecode(token);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);

            return null;
        }
    }
}
